<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>

      <Header title="Live Share" />
      <Gnb v-if="showGnb" />

      <!-- //header -->

      <div id="container" ref="container">
        <section id="contents">
          <div class="shareWrap">
            <ul class="shareList">
              <ListItem :item="item" v-bind:key="item.id" v-for="item in slides" />
              <li v-if="slides.length === 0">
                <div class="dt" style="text-align:center;">
                  <div class="title">등록된 슬라이드가 없습니다.</div>
                </div>
              </li>
            </ul>
          </div>
          <!-- shareWrap -->
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import ListItem from "@/components/slide/ListItem";
import Header from "@/components/SubHeaderWithSidebar";
import Gnb from "@/components/Gnb";
import sideMixin from "@/components/SideMixin";
export default {
  mixins: [sideMixin],
  components: { ListItem, Header, Gnb },
  created: function() {
    this.$store.dispatch("loadSlideFullList");
  },
  computed: {
    slides: function() {
      return this.$store.state.paper_slides;
    },
    showGnb: function() {
      return this.$store.getters.getShowGnb;
    }
  }
};
</script>


<style lang="scss">
.shareWrap {
  min-height: 100vh;
  background: #282829;
  padding: 55px 0% 0;
}
.shareList {
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}
.shareList li {
}
.shareList li .dt {
  padding: 20px 0% 20px;
  font-size: 0;
  border-bottom: 1px solid rgba(107, 107, 107, 0.3);
}
.shareList li .dt > div {
  display: inline-block;
  vertical-align: middle;
}
.shareList li .dt .num {
  width: 15%;
  color: rgba(255, 255, 255, 0.2);
  font-size: 16px;
  text-align: center;
}
.shareList li .dt .title {
  width: 60%;
  color: #ffffff;
  font-size: 14px;
}
.shareList li .dt .apply {
  width: 25%;
}
.shareList li.noApply .dt .apply {
  opacity: 0.5;
}
.shareList li .dt .apply a {
  color: #ffffff;
  font-size: 10px;
  text-align: center;
  display: block;
}
.shareList li .dt .apply a img {
  width: 22%;
  display: block;
  margin: 0 auto 5px;
}
.shareList li .dt .apply .arrow {
  width: 12px;
  margin: 10px auto 0;
  display: block;
}

.shareList li .dd {
  padding: 10px 5% 10px 15%;
  border-bottom: 1px solid rgba(107, 107, 107, 0.3);
  background: #6a6f75;
  box-shadow: black 5px 5px 15px -10px inset;
  font-size: 0;
}
.shareList li .dd p {
  color: #ffffff;
  font-size: 12px;
  font-family: "NotoKrL";
  font-weight: 100;
}
.shareList li .dd .inputWrap {
  margin-top: 10px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}
.shareList li .dd .inputWrap input {
  height: 30px;
  border-radius: 5px;
  background: #ffffff;
  border: none;
  padding: 0 10px;
}
.shareList li .dd .inputWrap input.mail1 {
  width: 20%;
}
.shareList li .dd .inputWrap input.mail2 {
  width: 50%;
}
.shareList li .dd .inputWrap a {
  height: 30px;
  line-height: 30px;
  text-align: center;
  width: 20%;
  background: #58af70;
  border-radius: 5px;
  display: inline-block;
  vertical-align: top;
  color: #fff;
  font-size: 13px;
  margin-left: 1%;
}
</style>